import { render, staticRenderFns } from "./exam_image_pairs.vue?vue&type=template&id=17b3f32d&scoped=true&"
import script from "./exam_image_pairs.vue?vue&type=script&lang=js&"
export * from "./exam_image_pairs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b3f32d",
  null
  
)

export default component.exports